import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
// import { Link } from '@bd/bdcore-named-routes';
import { colors, typography } from '../../styles';

const styles = css`
  background-size:cover;
  background-position: center;
  padding:40px 0;
  text-align:center;
  border-top:1px solid #ddd;
  padding:100px 0 200px 0;
  margin-bottom: -200px;
  @media (min-width: 480px) {
    padding:100px 0 240px 0;
    margin-bottom: -200px;
  }
  .HoaPortal_Content {
    background-size:cover;
    background-position: center;
    display: block;
    width:100%;
    margin:0 auto;
    padding-top:160%;
    position: relative;
    @media (min-width: 480px) {
      padding-top:100%;
    }
    @media (min-width: 768px) {
      padding-top:56%;
    }
  }
  .HoaPortal-Headline-Wrapper {
    position: absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
    padding:0 20px;
    display: flex;
    flex-flow:column wrap;
    justify-content: center;
  }
  .HoaPortal-Headline {
    font:900 30px/36px ${typography.SansSerif};
    color:white;
    padding:0 0 30px 0;
    text-transform: uppercase;
    padding:20px 0;
    border-top:1px solid ${colors.color2};
    border-bottom:1px solid ${colors.color2};
    margin: 0 auto;
    @media (min-width: 768px) {
      font:900 36px/42px ${typography.SansSerif};
    }
  }

`;

function HomeContent({ page }) {
  return (
    <div className={styles} style={{ backgroundImage: `linear-gradient(to bottom, rgba(216,216,216,0.2) 0%,rgba(216,216,216,0.2) 100%), url(${buildThumbnailUrl(get(page, 'hoa_portal[0].section_background.contentUrl'), { width: 2000, height: 1000, exact: true })})` }}>
      <div className="container">
        {
          get(page, 'hoa_portal').map(item => (
            <a href={item.link_url} key="item.cta_headline" className="HoaPortal_Content" style={{ backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.5) 0%,rgba(0,0,0,0.5) 100%), url(${buildThumbnailUrl(get(item, 'cta_background.contentUrl'), { width: 1000, height: 600, exact: true })})` }}>
              <div className="HoaPortal-Headline-Wrapper">
                <h3 className="HoaPortal-Headline">{get(item, 'cta_headline')}</h3>
                {/* <Link className="btn" name="about-us">{get(item, 'button_label')}</Link> */}
              </div>
            </a>
          ))
        }
      </div>
    </div>
  );
}

HomeContent.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'homepage',
})(HomeContent);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/HoaPortal.js